export class ScrChecker {
    constructor() {
        this.inviewElems = []; //inviewで効果をつける要素を登録する
        this.initAfterOpeningFlg = false; //templateの関係でinview要素を再度確認
    }
    setProps(el, props) {
        for (let key in props) {
            el.style.setProperty('--' + key, props[key]);
        }
    };
    clamp(v, min, max) {
        return min > v ? min : max < v ? max : v;
    }
    round(n) {
        return Math.round(n * 10000) / 10000;
    }

    calcElementOffsetY(elem) {
        let container = window;

        let parentElem;
        if (elem.parentElement) {
            parentElem = elem.parentElement;
        }
        let target = parentElem;

        // ページ全体に対するY座標を計算
        let numY = 0;
        do {
            numY += target.offsetTop; //target.offsetTop;はノードの上端に対しての現在の要素の距離
            target = target.offsetParent;
            //console.log(target);
        } while (target && target !== container); //要素のcontainerに対するY座標

        return numY;
    }


    onUpdate() {

        //ウインドウ情報 ie11未対応
        //let windowWidth = window.innerWidth;
        //let windowHeight = window.innerHeight;
        //let windowOffsetY = window.scrollY;

        //ウインドウ情報など ie11対応
        let windowLeft = (window.screenLeft || window.screenX || 0);
        let windowTop = (window.screenTop || window.screenY || 0);
        let windowWidth = (window.innerWidth || document.documentElement.clientWidth || 0);
        let windowHeight = (window.innerHeight || document.documentElement.clientHeight || 0);
        let windowScrollY = window.scrollY || window.pageYOffset;
        let windowScrollX = window.scrollX || window.pageXOffset;


        //console.log(windowScrollY);
        this.body = document.getElementsByTagName('body')[0];
        this.html = document.getElementsByTagName('html')[0];

        if (windowScrollY > windowHeight) {
            this.body.classList.add('scrolled-windowheight');
        } else {
            this.body.classList.remove('scrolled-windowheight');
        }

        if (this.body.classList.contains('index')) {
            //this.body.classList.remove('scrolled-title');
        } else {
            if (windowScrollY > 200) {
                this.body.classList.add('scrolled-title');
            } else {
                this.body.classList.remove('scrolled-title');
            }
        }


        // ===========
        // inview判定

        if (!this.initAfterOpeningFlg) {
            if (this.body.classList.contains('opening-finished') || this.body.classList.contains('opening-skipped')) {
                this.initAfterOpeningFlg = true;
                this.init();
            }
        }

        //.js-anim-inview に .inview 追加
        if (this.inviewElems.length !== 0) {
            //inviewElems = document.querySelectorAll('.js-anim-inview');//複数
            [].forEach.call(this.inviewElems, (elem) => {
                //console.log(elem.classList);
                let clientRect = elem.getBoundingClientRect(); // 要素の位置座標
                let y = clientRect.top; //画面の上端から、要素の上端までの距離
                //let elemY = window.pageYOffset + clientRect.top;// ページの上端から、要素の上端までの距離

                //表示タイミング ウインドウ上端から
                let showPos = windowHeight * 0.7;
                if (windowWidth > 600) {
                    showPos = windowHeight * 0.8; //0.5; //pc
                }

                if (showPos > y) {
                    if (this.body.classList.contains('loaded')) {
                        elem.classList.add('inview');
                    } else {
                        //elem.classList.add('inview');
                    }
                }
            });
        }


    }


    // 初期化
    init() {
        this.inviewElems = document.querySelectorAll('.js-inview'); //複数
    }
}